var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgReferralBack = function SvgReferralBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "referral-back_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 307 326"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23",
    x1: 127.35,
    y1: 201.92,
    x2: 130.84,
    y2: 201.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4d4ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f1c794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e9a756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_41",
    x1: -919.79,
    y1: 201.71,
    x2: -916.77,
    y2: 201.71,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fc1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52a0d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_41-2",
    x1: -916.66,
    y1: 198.07,
    x2: -911.9,
    y2: 198.07,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_26",
    x1: -928.72,
    y1: 191.64,
    x2: -912.27,
    y2: 202.17,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbefe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f8e2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f0c28a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e69b3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_26-2",
    x1: -929.29,
    y1: 190.77,
    x2: -920.94,
    y2: 196.81,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_41-3",
    x1: -923.71,
    y1: 195.65,
    x2: -921.52,
    y2: 195.65,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-2",
    x1: 111.93,
    y1: 199.12,
    x2: 114.78,
    y2: 199.12,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-3",
    x1: 110.94,
    y1: 195.41,
    x2: 116.94,
    y2: 195.41,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_40",
    x1: -913.24,
    y1: 185.86,
    x2: -897.83,
    y2: 194.99,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9c9c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4",
    x1: -908.81,
    y1: 236.98,
    x2: -902.25,
    y2: 236.98,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_40-2",
    x1: -915.02,
    y1: 254.91,
    x2: -904.9,
    y2: 253.85,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_40-3",
    x1: -904.48,
    y1: 255.41,
    x2: -894.36,
    y2: 253.58,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-2",
    x1: -906.05,
    y1: 235.54,
    x2: -896.53,
    y2: 235.54,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_38",
    x1: -888.06,
    y1: 224.43,
    x2: -920.44,
    y2: 194.87,
    gradientTransform: "matrix(-1 0 0 1 -789.14 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66abd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#add8d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ceecd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-4",
    x1: 106.86,
    y1: 225.05,
    x2: 109.58,
    y2: 225.05,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-5",
    x1: 129.35,
    y1: 201.53,
    x2: 130.92,
    y2: 201.53,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-3",
    x1: 79.46,
    y1: 225.48,
    x2: 88.1,
    y2: 295.47,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient",
    x1: 74.58,
    y1: 226.55,
    x2: 93.42,
    y2: 226.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-4",
    x1: 66.97,
    y1: 219.49,
    x2: 77.81,
    y2: 217.57,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-5",
    x1: 100.82,
    y1: 219.26,
    x2: 90.06,
    y2: 218.5,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-6",
    x1: 83.63,
    y1: 203.36,
    x2: 84.78,
    y2: 233.02,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-2",
    x1: 75.67,
    y1: 244.04,
    x2: 103.72,
    y2: 275.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8cdb97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#97dda3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aee0bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-3",
    x1: 1068.94,
    y1: -346.28,
    x2: 1093.59,
    y2: -346.28,
    gradientTransform: "rotate(-80.87 931.642 525.47)",
    xlinkHref: "#referral-back_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-4",
    x1: 1066.68,
    y1: -351.51,
    x2: 1093.41,
    y2: -351.51,
    gradientTransform: "rotate(-80.87 931.642 525.47)",
    xlinkHref: "#referral-back_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-5",
    x1: 109.87,
    y1: 273.14,
    x2: 109.87,
    y2: 272.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#90d4a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27ac4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-6",
    x1: 109.85,
    y1: 277.34,
    x2: 109.87,
    y2: 276.81,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-7",
    x1: 109.83,
    y1: 273.38,
    x2: 109.95,
    y2: 278.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94d6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b5e3c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ceecd6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-8",
    x1: 108.16,
    y1: 268.54,
    x2: 108.16,
    y2: 268.18,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-9",
    x1: 108.15,
    y1: 272.75,
    x2: 108.16,
    y2: 272.21,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-10",
    x1: 108.12,
    y1: 268.78,
    x2: 108.24,
    y2: 273.45,
    xlinkHref: "#referral-back_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-11",
    x1: 109.87,
    y1: 263.95,
    x2: 109.87,
    y2: 263.58,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-12",
    x1: 109.85,
    y1: 268.15,
    x2: 109.87,
    y2: 267.62,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-13",
    x1: 109.83,
    y1: 264.19,
    x2: 109.95,
    y2: 268.86,
    xlinkHref: "#referral-back_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-14",
    x1: 108.16,
    y1: 259.35,
    x2: 108.16,
    y2: 258.99,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-15",
    x1: 108.15,
    y1: 263.56,
    x2: 108.16,
    y2: 263.02,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-16",
    x1: 108.12,
    y1: 259.59,
    x2: 108.24,
    y2: 264.26,
    xlinkHref: "#referral-back_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-17",
    x1: 109.03,
    y1: 254.76,
    x2: 109.03,
    y2: 254.39,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-18",
    x1: 109.01,
    y1: 258.96,
    x2: 109.03,
    y2: 258.43,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-19",
    x1: 108.99,
    y1: 255,
    x2: 109.11,
    y2: 259.67,
    xlinkHref: "#referral-back_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_39",
    x1: 122.49,
    y1: 276.81,
    x2: 122.5,
    y2: 276.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84bbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#77b4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#55a1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1d82c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b81c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-20",
    x1: 110.29,
    y1: 267.61,
    x2: 136.43,
    y2: 267.61,
    xlinkHref: "#referral-back_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-21",
    x1: 122.57,
    y1: 279.56,
    x2: 124.15,
    y2: 255.67,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-22",
    x1: 128.87,
    y1: 275.22,
    x2: 117.63,
    y2: 259.69,
    xlinkHref: "#referral-back_svg__linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-23",
    x1: 118.69,
    y1: 267.61,
    x2: 127.89,
    y2: 267.61,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-24",
    x1: 112.83,
    y1: 276.45,
    x2: 133.89,
    y2: 276.45,
    xlinkHref: "#referral-back_svg__linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-25",
    x1: 599.42,
    y1: 219.53,
    x2: 605.59,
    y2: 219.53,
    gradientTransform: "matrix(-1 0 0 1 838.18 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-6",
    x1: 229.51,
    y1: 218.36,
    x2: 231.58,
    y2: 218.36,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_38-2",
    x1: 240.19,
    y1: 239.59,
    x2: 222.01,
    y2: 218.18,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-7",
    x1: -516.2,
    y1: 255.42,
    x2: -503.91,
    y2: 255.42,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-8",
    x1: -519.43,
    y1: 255.42,
    x2: -512.56,
    y2: 255.42,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-7",
    x1: 228.02,
    y1: 215.87,
    x2: 232.59,
    y2: 215.87,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_38-3",
    x1: 231.88,
    y1: 230.19,
    x2: 214.43,
    y2: 219.92,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-26",
    x1: -518,
    y1: 276.58,
    x2: -513.7,
    y2: 276.58,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-27",
    x1: -515.88,
    y1: 275.75,
    x2: -513.83,
    y2: 275.75,
    gradientTransform: "translate(743.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1f3e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c9ead2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#8bd29e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43b762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-28",
    x1: -508.05,
    y1: 276.58,
    x2: -503.74,
    y2: 276.58,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-29",
    x1: -505.93,
    y1: 275.75,
    x2: -503.88,
    y2: 275.75,
    xlinkHref: "#referral-back_svg__linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-30",
    x1: -523.54,
    y1: 219.23,
    x2: -521.88,
    y2: 219.23,
    gradientTransform: "translate(743.29)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-31",
    x1: -522.62,
    y1: 219.2,
    x2: -522,
    y2: 219.2,
    xlinkHref: "#referral-back_svg__linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-8",
    x1: 219.89,
    y1: 221.97,
    x2: 223.16,
    y2: 221.97,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-32",
    x1: -522.62,
    y1: 220.02,
    x2: -521.6,
    y2: 220.02,
    xlinkHref: "#referral-back_svg__linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-9",
    x1: 220.53,
    y1: 221.47,
    x2: 224.34,
    y2: 221.47,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_38-4",
    x1: 236.37,
    y1: 230.73,
    x2: 221.11,
    y2: 216.35,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-33",
    x1: 604.79,
    y1: 215.04,
    x2: 610.16,
    y2: 215.04,
    gradientTransform: "matrix(-1 0 0 1 838.18 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-34",
    x1: 601.33,
    y1: 223.03,
    x2: 601.4,
    y2: 223.03,
    gradientTransform: "matrix(-1 0 0 1 838.18 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-10",
    x1: 170.98,
    y1: 218.79,
    x2: 173.02,
    y2: 218.79,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-35",
    x1: 168.59,
    y1: 227.47,
    x2: 175.49,
    y2: 227.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#a3cce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8dc0e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-36",
    x1: 175.08,
    y1: 234.39,
    x2: 178.16,
    y2: 234.39,
    xlinkHref: "#referral-back_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-9",
    x1: 168.59,
    y1: 255.31,
    x2: 180.71,
    y2: 255.31,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-37",
    x1: 170.54,
    y1: 231.06,
    x2: 176.96,
    y2: 231.06,
    xlinkHref: "#referral-back_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-10",
    x1: 165.41,
    y1: 255.31,
    x2: 172.18,
    y2: 255.31,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-11",
    x1: 169.52,
    y1: 216.33,
    x2: 174.01,
    y2: 216.33,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-38",
    x1: 162.08,
    y1: 225.68,
    x2: 169.68,
    y2: 225.68,
    xlinkHref: "#referral-back_svg__linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-39",
    x1: 166.82,
    y1: 276.16,
    x2: 171.06,
    y2: 276.16,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-40",
    x1: 168.91,
    y1: 275.34,
    x2: 170.93,
    y2: 275.34,
    xlinkHref: "#referral-back_svg__linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-41",
    x1: 176.63,
    y1: 276.16,
    x2: 180.87,
    y2: 276.16,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-42",
    x1: 178.72,
    y1: 275.34,
    x2: 180.74,
    y2: 275.34,
    xlinkHref: "#referral-back_svg__linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-43",
    x1: 161.36,
    y1: 219.65,
    x2: 162.99,
    y2: 219.65,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-12",
    x1: 162.27,
    y1: 219.62,
    x2: 162.88,
    y2: 219.62,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-13",
    x1: 161.5,
    y1: 220.49,
    x2: 163.27,
    y2: 220.49,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-14",
    x1: 162.27,
    y1: 220.43,
    x2: 163.27,
    y2: 220.43,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-15",
    x1: 169.58,
    y1: 240.98,
    x2: 171.77,
    y2: 240.98,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-44",
    x1: 168.03,
    y1: 220.04,
    x2: 181.5,
    y2: 220.04,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-45",
    x1: 752.9,
    y1: 276.55,
    x2: 758.06,
    y2: 276.55,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-46",
    x1: 742.62,
    y1: 276.55,
    x2: 747.78,
    y2: 276.55,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-16",
    x1: 204.15,
    y1: 216.15,
    x2: 205.66,
    y2: 216.15,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-47",
    x1: 745.02,
    y1: 214.78,
    x2: 751.67,
    y2: 214.78,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-17",
    x1: 204.91,
    y1: 218.12,
    x2: 207.02,
    y2: 218.12,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-11",
    x1: 742.6,
    y1: 257.75,
    x2: 748.78,
    y2: 257.75,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_26-3",
    x1: 742.69,
    y1: 229.66,
    x2: 764.17,
    y2: 229.66,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_4-12",
    x1: 742.69,
    y1: 257.75,
    x2: 755.71,
    y2: 257.75,
    gradientTransform: "matrix(-1 0 0 1 954.12 0)",
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__New_Gradient_Swatch_copy_23-18",
    x1: 188.9,
    y1: 219.8,
    x2: 191,
    y2: 219.8,
    xlinkHref: "#referral-back_svg__New_Gradient_Swatch_copy_23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-48",
    x1: 190.41,
    y1: 190.55,
    x2: 192.48,
    y2: 182.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aee0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#93d5a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#72c989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#55be71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3eb55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2dae4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#20aa45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#19a73f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17a63d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-49",
    x1: -448.16,
    y1: 575.86,
    x2: -445.13,
    y2: 575.86,
    gradientTransform: "matrix(-.51 -.16 -.3 .95 135.26 -434.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5e9cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8dd3a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-50",
    x1: -448.21,
    y1: 578.37,
    x2: -448.19,
    y2: 573.2,
    gradientTransform: "matrix(0 -.54 -1 0 767.16 -54.07)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-51",
    x1: -448.17,
    y1: 580.55,
    x2: -448.15,
    y2: 573.81,
    gradientTransform: "matrix(-.51 -.16 -.3 .95 135.26 -434.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aee0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#96d7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#59bf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17a63d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-52",
    x1: -448.68,
    y1: 575.88,
    x2: -447.68,
    y2: 575.88,
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-53",
    x1: 159.35,
    y1: 196.15,
    x2: 151.01,
    y2: 190.87,
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-54",
    x1: 155.12,
    y1: 195.59,
    x2: 154.61,
    y2: 196.67,
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-55",
    x1: 1511.29,
    y1: -932.43,
    x2: 1511.3,
    y2: -937.91,
    gradientTransform: "matrix(-1 0 0 1 1667.25 1129.1)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-56",
    x1: 161.9,
    y1: 197.82,
    x2: 153.68,
    y2: 192.53,
    gradientTransform: "rotate(44.47 156.009 194.04)",
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-57",
    x1: 593.03,
    y1: -873.51,
    x2: 594.09,
    y2: -873.51,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-58",
    x1: 171.82,
    y1: 176.59,
    x2: 166.66,
    y2: 173.32,
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-59",
    x1: 169.2,
    y1: 176.25,
    x2: 168.88,
    y2: 176.91,
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-60",
    x1: 1488.36,
    y1: -937.2,
    x2: 1488.37,
    y2: -940.59,
    gradientTransform: "matrix(-1 0 0 1 1658.06 1114.1)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-61",
    x1: 173.4,
    y1: 177.63,
    x2: 168.31,
    y2: 174.35,
    gradientTransform: "rotate(44.47 169.755 175.288)",
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-62",
    x1: 615.44,
    y1: -880.33,
    x2: 616.1,
    y2: -880.33,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-63",
    x1: 155.23,
    y1: 251.2,
    x2: 150.06,
    y2: 247.92,
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-64",
    x1: 152.61,
    y1: 250.85,
    x2: 152.29,
    y2: 251.52,
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-65",
    x1: 1552.47,
    y1: -895.58,
    x2: 1552.47,
    y2: -898.97,
    gradientTransform: "matrix(-.71 .7 .7 .71 1889.53 -197.38)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-66",
    x1: 156.81,
    y1: 252.23,
    x2: 151.71,
    y2: 248.96,
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-67",
    x1: 557.54,
    y1: -830.45,
    x2: 558.19,
    y2: -830.45,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-68",
    x1: 231.2,
    y1: 180.02,
    x2: 226.04,
    y2: 176.75,
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-69",
    x1: 228.59,
    y1: 179.67,
    x2: 228.27,
    y2: 180.34,
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-70",
    x1: 1448.38,
    y1: -893.15,
    x2: 1448.39,
    y2: -896.54,
    gradientTransform: "matrix(-1 0 0 1 1677.46 1073.5)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-71",
    x1: 232.79,
    y1: 181.05,
    x2: 227.69,
    y2: 177.78,
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-72",
    x1: 660.99,
    y1: -842.08,
    x2: 661.65,
    y2: -842.08,
    gradientTransform: "rotate(-36.72 1983.132 319.43)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-73",
    x1: 998.45,
    y1: 202.24,
    x2: 993.29,
    y2: 198.96,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-74",
    x1: 995.83,
    y1: 201.89,
    x2: 995.51,
    y2: 202.56,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-75",
    x1: 916.4,
    y1: -339.8,
    x2: 916.41,
    y2: -343.19,
    gradientTransform: "matrix(.71 .7 -.7 .71 -675.2 -197.38)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-76",
    x1: 1000.03,
    y1: 203.27,
    x2: 994.94,
    y2: 200,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-77",
    x1: 1262.7,
    y1: -365.56,
    x2: 1263.36,
    y2: -365.56,
    gradientTransform: "matrix(-.8 -.6 -.6 .8 1011.79 1249.11)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-78",
    x1: 1082.93,
    y1: 226.71,
    x2: 1075.5,
    y2: 221.99,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-79",
    x1: 1079.16,
    y1: 226.21,
    x2: 1078.7,
    y2: 227.17,
    gradientTransform: "matrix(-1 0 0 1 1214.32 0)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-80",
    x1: 873.48,
    y1: -263.48,
    x2: 873.49,
    y2: -268.36,
    gradientTransform: "rotate(90 258.57 -390.09)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-81",
    x1: 1085.21,
    y1: 228.19,
    x2: 1077.87,
    y2: 223.48,
    gradientTransform: "matrix(-.7 -.71 -.71 .7 1051.35 837.98)",
    xlinkHref: "#referral-back_svg__linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral-back_svg__linear-gradient-82",
    x1: 1315.28,
    y1: -296.44,
    x2: 1316.22,
    y2: -296.44,
    gradientTransform: "matrix(-.8 -.6 -.6 .8 1011.79 1249.11)",
    xlinkHref: "#referral-back_svg__linear-gradient-49"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "referral-back_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h307v326H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".referral-back_svg__cls-3{opacity:.05}.referral-back_svg__cls-21{opacity:.1}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#referral-back_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "referral-back_svg__cls-3",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.64 21.09s6 118.93-111.73 109.7-53.69 62.15-105.31 84.3-118.22-30.35-215.66-6.33 46.84 118.78-265.5 118.78h698.23z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.64 0S313 127.12 187.22 117.25s-57.38 66.43-112.56 90.1-126.35-32.43-230.49-6.76 50.06 127-283.77 127h746.27z",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.35 201.31s2.26-1.77 2.93-1 .67 2.5.37 2.63-2 .79-2.08.85a18.51 18.51 0 01-1.22-2.48z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 204.34l1.61-.52-.72-4.75-2.29.73z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 199.15a2.49 2.49 0 003.33 1.37l1.24-.44a7.93 7.93 0 01-1.15-2.22 9.15 9.15 0 01-.59-2.42l-1.24.44a2.43 2.43 0 00-1.59 3.27z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_41-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22 200.37s-.09.11-.55 0a12.5 12.5 0 00-9 .12c-.3.1-.93-.89-1.42-2.23s-.66-2.5-.36-2.6a12.23 12.23 0 007-5.59c.1-.14.06 0 .13-.08-.5.66-.06 2.84.94 5.53 1.04 2.94 2.5 5.14 3.26 4.85z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 194.4c1.21 2.86 1.73 5.53 1.18 6s-2-1.53-3.17-4.39-1.74-5.53-1.19-6 2 1.53 3.18 4.39z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_26-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47 195.12a1.54 1.54 0 01-.87 2h-.09c-.26-.51-.5-1.07-.73-1.65-.15-.41-.28-.79-.4-1.18l.12-.05a1.52 1.52 0 011.97.88z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_41-3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-2)",
    d: "M114.78 201.27l-.04-2.95-2.81-1.74v5.08l2.85-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.73 196.32s.32 2.4 2.24 2.4 2.88.16 2.88-1.76.48-3.83-.8-4.47-4.48-.8-4.32 1.92c0 0-.79-.64-.79.32s0 1.91.79 1.59z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.73 196.8s-5-3.67-1.59-6.23 4.31.48 7.35-1.6c0 0 2.87 2.4-.8 4 0 0-4.56-.56-4.24 2a1.33 1.33 0 00-1.27-.48c-.8.16.31 1.75.55 2.31z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_40)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4)",
    d: "M119.67 253.22h-1.92L113.12 232l3.53-11.26 2.19.13.83 32.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.76 253.15l-.37 1.2a.66.66 0 00.63.86h5.55s.13-1-1.16-1.29a12.71 12.71 0 01-2.45-.77z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_40-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.34 253.15l-.37 1.2a.67.67 0 00.64.86h5.54s.13-1-1.16-1.29a12.71 12.71 0 01-2.45-.77z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_40-3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-2)",
    d: "M116.91 219.46l-8.75-1.55-.77 35.25h2.19l7.33-33.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35 201.31l-4.88 7.2-2.88-6.71a3.65 3.65 0 00-2.67-2.15 32.91 32.91 0 00-3.61-.13 12.69 12.69 0 00-4.1.4 4.12 4.12 0 00-2.91 3.29c-.5 3-1.22 8-1 10.46a89.58 89.58 0 001.8 9.26h2.06l-.38-2.32 11.06.39-1.1-10 1.07 1.15a4.51 4.51 0 002 1.22c.84.16 1.58-.5 2.23-1.05l4.49-8.6z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.19 222.93a11.06 11.06 0 01.39 1.67c0 .39-.13.77-.39.39s-.13.9 0 1.54-1 1-1.93 0 0-3.6 0-3.6z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "referral-back_svg__cls-21",
    d: "M118.84 210.97v-5.15l1.02 6.38-1.02-1.23zM108.81 220.74a57.54 57.54 0 01-.39-6.81 39.57 39.57 0 01.9-5.41l.52 12.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.92 202.9a1.08 1.08 0 01-1-.43c-.37-.55-.79-2-.31-2.14s.92-.43 1 .37",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.73 201s.51-.52.73-.45.11.24.11.42-.67.55-.67.55z",
    fill: "#a0dab0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07 260.47c-2.63-17.18-17.58-32.75-17.58-32.75H75.6S60.66 243.29 58 260.47a14 14 0 0013.9 16.19h24.3a14 14 0 0013.87-16.19z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.42 226.56a1.17 1.17 0 01-1.17 1.16H75.74a1.17 1.17 0 010-2.33h16.51a1.17 1.17 0 011.17 1.17z",
    fill: "url(#referral-back_svg__linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.06 225.39h-1.32c-.78-2.32-6.41-6.83-7.58-8s3.54-3.38 4.67-4.18c.71-.51.23-1.63-.22-2.41 1.04 1.6 3.67 6.39 4.45 14.59z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25 225.39h-.83c.34-4.82 3-12 3.6-13.34a3.87 3.87 0 00.1 1.75c.56 1.8 3.65 1.07 4.46 3.67s-6.13 3.67-7.33 7.92z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6 210.17A6.66 6.66 0 0095 212c-.55 1.38-3.26 8.52-3.6 13.34H77.06c-.78-8.2-3.41-13-4.45-14.59l-.12-.19c-.18-.28-.29-.42-.29-.42a.21.21 0 01.08-.3c1.74-.74 15-8.59 23.23 0a.26.26 0 01.09.33z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.17 267.58v-3.37a14.37 14.37 0 01-6-1.53l1.07-4.15a12.59 12.59 0 005.89 1.56c2 0 3.41-.78 3.41-2.2s-1.14-2.2-3.76-3.09c-3.8-1.28-6.39-3.05-6.39-6.49 0-3.13 2.2-5.58 6-6.32v-3.38h3.47v3.13a12.64 12.64 0 015.14 1.17l-1 4a11.73 11.73 0 00-5.11-1.21c-2.31 0-3 1-3 2 0 1.17 1.24 1.92 4.26 3.05 4.22 1.5 5.93 3.45 5.93 6.64s-2.24 5.86-6.32 6.57v3.62z",
    fill: "url(#referral-back_svg__linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.76 252.39a1 1 0 01-.84.83c-6.28.87-7.41-4.45-8.71-10.61-.36-1.71-.74-3.48-1.24-5.35-2.21-8.24-10.57-9.88-10.65-9.89a1 1 0 01.36-2c.4.07 9.68 1.89 12.22 11.33.51 1.92.91 3.8 1.26 5.46 1.42 6.7 2.23 9.64 6.48 9.05a1 1 0 011.13.85.93.93 0 01-.01.33z",
    fill: "url(#referral-back_svg__linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05 253.32a.76.76 0 01-.11.32 1 1 0 01-1.35.39c-3.54-1.94-3.38-5-2-13.87 1.32-8.23-7.27-12.53-7.64-12.7a1 1 0 01-.46-1.34 1 1 0 011.33-.46c.11.05 10.3 5.11 8.74 14.82-1.51 9.35-1.14 10.66.94 11.81a1 1 0 01.55 1.03z",
    fill: "url(#referral-back_svg__linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49 273.21H97.25a2.24 2.24 0 011.43-.5h22.38a2.22 2.22 0 011.43.5z",
    fill: "url(#referral-back_svg__linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49 276.81a2.29 2.29 0 01-1.43.49H98.68a2.29 2.29 0 01-1.43-.49z",
    fill: "url(#referral-back_svg__linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.36 275a2.3 2.3 0 01-.67 1.62l-.2.18H97.25a2.29 2.29 0 01-.87-1.8 2.32 2.32 0 01.67-1.63l.2-.17h25.24a2.29 2.29 0 01.87 1.8z",
    fill: "url(#referral-back_svg__linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.79 268.61H95.54a2.3 2.3 0 011.43-.5h22.39a2.32 2.32 0 011.43.5z",
    fill: "url(#referral-back_svg__linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78 272.21a2.29 2.29 0 01-1.42.5H97a2.3 2.3 0 01-1.43-.5z",
    fill: "url(#referral-back_svg__linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65 270.41A2.26 2.26 0 01121 272a1.12 1.12 0 01-.2.18H95.54a2.3 2.3 0 01-.2-3.42l.2-.18h25.25a2.31 2.31 0 01.86 1.83z",
    fill: "url(#referral-back_svg__linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49 264H97.25a2.24 2.24 0 011.43-.5h22.38a2.24 2.24 0 011.43.5z",
    fill: "url(#referral-back_svg__linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49 267.61a2.24 2.24 0 01-1.43.5H98.68a2.24 2.24 0 01-1.43-.5z",
    fill: "url(#referral-back_svg__linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.36 265.81a2.32 2.32 0 01-.67 1.63l-.2.17H97.25a2.29 2.29 0 01-.87-1.8 2.32 2.32 0 01.67-1.62l.2-.17h25.24a2.29 2.29 0 01.87 1.79z",
    fill: "url(#referral-back_svg__linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.79 259.42H95.54a2.3 2.3 0 011.43-.5h22.39a2.32 2.32 0 011.43.5z",
    fill: "url(#referral-back_svg__linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78 263a2.29 2.29 0 01-1.42.5H97a2.3 2.3 0 01-1.43-.5z",
    fill: "url(#referral-back_svg__linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65 261.22a2.26 2.26 0 01-.67 1.62l-.2.18H95.54a2.29 2.29 0 01-.87-1.8 2.32 2.32 0 01.67-1.63l.2-.17h25.25a2.31 2.31 0 01.86 1.8z",
    fill: "url(#referral-back_svg__linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65 254.83H96.41a2.24 2.24 0 011.43-.5h22.38a2.24 2.24 0 011.43.5z",
    fill: "url(#referral-back_svg__linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65 258.43a2.29 2.29 0 01-1.43.49H97.84a2.29 2.29 0 01-1.43-.49z",
    fill: "url(#referral-back_svg__linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.52 256.63a2.3 2.3 0 01-.67 1.62l-.2.18H96.41a2.29 2.29 0 01-.87-1.8 2.32 2.32 0 01.67-1.63l.2-.17h25.24a2.29 2.29 0 01.87 1.8z",
    fill: "url(#referral-back_svg__linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_39)",
    d: "M122.5 276.84h-.01v-.07l.01.07z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.36,
    cy: 267.61,
    r: 13.07,
    fill: "url(#referral-back_svg__linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.36 255.64a12 12 0 00-10.53 17.68 12 12 0 1010.53-17.68z",
    fill: "url(#referral-back_svg__linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.36,
    cy: 267.61,
    r: 8.95,
    fill: "url(#referral-back_svg__linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.49 274.91l-.5-1.63a7.35 7.35 0 01-3.15.14l-.1-2.17a6.31 6.31 0 003.09-.11c1-.3 1.54-.88 1.33-1.57s-.87-.9-2.28-.95c-2-.06-3.55-.54-4-2.21s.24-3 2-4l-.5-1.64 1.69-.51.46 1.52a6.34 6.34 0 012.67-.19l.09 2.1a6 6 0 00-2.66.16c-1.12.34-1.33.93-1.19 1.42s.89.75 2.52.85c2.27.11 3.39.8 3.86 2.36s-.23 3.17-2.11 4.11l.54 1.76z",
    fill: "url(#referral-back_svg__linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.89 273.31a12 12 0 01-21.06 0 13.07 13.07 0 0021.06 0z",
    opacity: 0.46,
    fill: "url(#referral-back_svg__linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.39 214.74a3.4 3.4 0 01-.08.57c0 1.36.94 1.46 1.3 1.13s0 1.34-.53 4.5a6 6 0 00.57 3.68 5.78 5.78 0 00.62.95c.55.66 1.16 1 1.55.83 1-.4 0-3.28 0-3.4a1.13 1.13 0 001.62 0c.91-.77-.39-1.1-1.3-6.59s-4.56-3.5-4.56-3.5a2.24 2.24 0 01.81 1.83z",
    fill: "url(#referral-back_svg__linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51 220.22c0 .41 1.45-1.25 1.83-1.5a3.47 3.47 0 00.12-.76c.06-.67.12-1.52.12-1.52a2.48 2.48 0 01-1.5 2.08.86.86 0 01-.38.06v.47c0 .27-.06.52-.09.76s-.09.3-.1.41z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79 235.62h-9.7c0-2.2 1-4.19 1.27-6.6a5.14 5.14 0 00-.17-2.27 19.9 19.9 0 01-1-2.17 2.73 2.73 0 01.28-1.55A10.72 10.72 0 01228 222a18 18 0 011.54-2.16c0 .16 0 .3-.05.41 0 .41 1.45-1.25 1.83-1.5a13.3 13.3 0 012.75 2.22 3.25 3.25 0 01.57.91 27.76 27.76 0 01.73 5c0 .08-.89 2.67-.39 3.78s2.08 3.43 1.81 4.96z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_38-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38 275.23h-1.79s-4.55-15.67-6-20.88c-.26-.93-.55-2-.85-3.12-.88-3.24-1.88-7.12-2.6-10.12a.14.14 0 010-.06.43.43 0 000-.05c-.46-1.92-.8-3.49-.93-4.34a5.83 5.83 0 01-.07-1h9.7c1.37 3.59.33 6.37-.72 17.17z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.43 275.23h-1.79s-3.53-19.35-3.77-20.88 3.22-18.73 3.22-18.73a5.83 5.83 0 00.07 1c.13.85.47 2.42.93 4.34a.43.43 0 010 .05.14.14 0 000 .06c.72 3 1.72 6.88 2.6 10.12 0 0-1.4 2.77-1.8 4s.54 20.04.54 20.04z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 215.06s.38 3.42 1.68 3.52a.86.86 0 00.38-.06 2.48 2.48 0 001.5-2.08c.19.12 1.2-.41.92-1.38s-.93-.46-1.18.44-.44.13-.7-.81-.35-.74-.82-1.28a.92.92 0 00-1.5.4c-.12.55-.28 1.25-.28 1.25z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.19 226.75s-3.86 3.81-4.89 2.95c-.49-.42-1.16-2.4-1.73-4.35l.52-.35 1.07-.64a11.13 11.13 0 001.11 2.22c.3.08 3.11-3.44 3.2-3.55a2.73 2.73 0 00-.28 1.55 19.9 19.9 0 001 2.17z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_38-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.59 277.57h-.7l-.09-.62-.94.62s-2.32.08-2.48 0-.1-.61.18-.69 1.53-.32 1.71-.72h.14c.32.08 1.08.21 1.25-.44.1-.39.8-.11.8-.11z",
    fill: "url(#referral-back_svg__linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46 275.65s-.7-.28-.8.11c-.17.65-.93.52-1.25.44.34-.26.23-1 .23-1h1.79z",
    fill: "url(#referral-back_svg__linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.55 277.57h-.71l-.08-.62-.95.62s-2.32.08-2.48 0-.1-.61.18-.69 1.53-.32 1.71-.72h.14c.32.08 1.08.21 1.25-.44.1-.39.8-.11.8-.11z",
    fill: "url(#referral-back_svg__linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.41 275.65s-.7-.28-.8.11c-.17.65-.93.52-1.25.44.34-.26.23-1 .23-1h1.79z",
    fill: "url(#referral-back_svg__linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.41 220.81l-.22.1-.25-.57-.2-.45-.12-.28-.25-.55-.61-1.38.21-.1.72 1.6.65 1.48z",
    fill: "url(#referral-back_svg__linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.18 219.42a.41.41 0 01-.5-.26c-.08-.16.48-.23.54-.2a.64.64 0 01.06.16v.06a.21.21 0 01-.1.24z",
    fill: "url(#referral-back_svg__linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.16 224.36l-1.07.64-1.09-3.27a1.45 1.45 0 00-.52-.5 4 4 0 00-.55-1c-.16-.12.19-.94.43-1.22a.44.44 0 01.12-.1c.2-.07.08.5.13.65.09 0 .1.13.1.27a1.28 1.28 0 000 .19c0 .07.08.16.19.26a4 4 0 00.39.3c.18.13.33.22.36.24s.81 1.94 1.51 3.54z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.69 220.88s-.18-.11-.36-.24l-.65-1.48a.41.41 0 00.5.26.21.21 0 00.11-.23c0 .2.11.77.12 1.05a1.18 1.18 0 00.28.64z",
    fill: "url(#referral-back_svg__linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.34 223.06l-.7 1.3-1.55-3.23a7.13 7.13 0 01-.8-.58c-.23-.22.06-1 0-1.11s-.54-.42-.65-.48-.22-.27-.1-.38a10.24 10.24 0 011.86.86l.48 1.44z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.11 230.28c-2.51 0-6-4.93-6-4.93l.53-1 .7-1.3s3 3.61 4.13 3.79c.61.1 1.5-1.83 1.5-1.83 1.9-3.32 3.21-4 3.78-4.08a.58.58 0 01.52.16c2.67 2.54-2.7 9.23-5.16 9.19z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_38-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 215.06s.14-.7.32-1.25a.92.92 0 011.5-.4c.47.54.57.34.82 1.28s.46 1.71.7.81.91-1.38 1.18-.44-.73 1.5-.92 1.38-.06.85-.12 1.52a4.53 4.53 0 001.85-2.65 3.4 3.4 0 00.08-.57 2.24 2.24 0 00-.8-1.8 3.23 3.23 0 00-2.81-.75c-2 .38-1.8 2.87-1.8 2.87z",
    fill: "url(#referral-back_svg__linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8 223.06h.05zm0 0z",
    fill: "url(#referral-back_svg__linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 216.9s-.15 2.19-.23 2.24c-.38.25-1.85 1.88-1.81 1.48 0-.1 0-.24.05-.4s.06-.52.08-.75.06-.46.06-.46a.82.82 0 00.37-.06 2.47 2.47 0 001.48-2.05z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 232.72l-1.57 3.08h-3.85c0-2.17 1-4.13 1.25-6.51a5 5 0 00-.16-2.23 17.68 17.68 0 01-1-2.14 2.64 2.64 0 01.27-1.53 15.31 15.31 0 012.06-3.17c0 .16 0 .3-.05.4 0 .4 1.43-1.23 1.81-1.48a13.17 13.17 0 012.7 2.19c-4.66.19-1.46 11.39-1.46 11.39z",
    fill: "url(#referral-back_svg__linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16 235.8h-3.08a26.77 26.77 0 001.66-2.81 19 19 0 011.42 2.81z",
    fill: "url(#referral-back_svg__linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.71 274.83h-1.77s-4.48-15.44-5.92-20.58c-.26-.92-.54-2-.84-3.07-.87-3.19-1.85-7-2.56-10a.14.14 0 010-.06.43.43 0 000-.05c-.45-1.9-.79-3.44-.92-4.27a7.05 7.05 0 01-.07-1h9.57c1.34 3.53.32 6.27-.72 16.92z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74 233a26.77 26.77 0 01-1.66 2.81c-1.46 2.27-3.31 5-3.31 5l-1.23-1.27 1.9-3.71 1.57-3.08s-3.21-11.2 1.48-11.39a3.27 3.27 0 01.56.89 27.3 27.3 0 01.73 4.93c.22 2.47.27 5.07-.04 5.82z",
    fill: "url(#referral-back_svg__linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9 274.83h-1.77s-3.47-19.07-3.71-20.58 3.17-18.45 3.17-18.45a7.05 7.05 0 00.07 1c.13.83.47 2.37.92 4.27a.43.43 0 010 .05.14.14 0 000 .06c.71 2.95 1.69 6.78 2.56 10 0 0-1.38 2.73-1.77 3.92s.53 19.73.53 19.73z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05 216.9a2.47 2.47 0 01-1.48 2 .82.82 0 01-.37.06c-1.29-.1-1.65-3.47-1.65-3.47s.13-.69.3-1.23a.91.91 0 011.48-.4c.46.53.57.34.82 1.26s.45 1.69.69.81.89-1.37 1.16-.44a1.06 1.06 0 01-.95 1.41z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.68 227.06s-3.81 3.75-4.82 2.9-2.78-8.35-2.78-8.35l1.19-.34s2.26 5.54 2.55 5.62 3.07-3.39 3.15-3.5a2.64 2.64 0 00-.27 1.53 17.68 17.68 0 00.98 2.14z",
    fill: "url(#referral-back_svg__linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.06 277.13h-.69l-.09-.6-.93.6a22 22 0 01-2.44 0c-.16-.07-.1-.59.18-.67s1.51-.32 1.69-.72h.13c.31.09 1.06.21 1.23-.43.1-.38.79-.11.79-.11z",
    fill: "url(#referral-back_svg__linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93 275.24s-.69-.27-.79.11c-.17.64-.92.52-1.23.43.34-.25.22-.95.22-.95h1.77z",
    fill: "url(#referral-back_svg__linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87 277.13h-.7l-.08-.6-.93.6a22.2 22.2 0 01-2.45 0c-.16-.07-.1-.59.18-.67s1.51-.32 1.69-.72h.14c.31.09 1.06.21 1.23-.43.1-.38.79-.11.79-.11z",
    fill: "url(#referral-back_svg__linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74 275.24s-.69-.27-.79.11c-.17.64-.92.52-1.23.43.33-.25.22-.95.22-.95h1.77z",
    fill: "url(#referral-back_svg__linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 221.21l-.21.09-.24-.56-.2-.44-.12-.28-.24-.54-.61-1.36.21-.1.7 1.58.65 1.46z",
    fill: "url(#referral-back_svg__linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77 219.83a.42.42 0 01-.5-.25c-.07-.16.48-.23.54-.2a.64.64 0 01.06.16.2.2 0 01-.1.29z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.27 221.27l-1.19.34a4.25 4.25 0 00-.54-1c-.16-.11.18-.92.43-1.2a.32.32 0 01.11-.1c.2-.07.08.49.13.64.08 0 .09.12.1.26a1.34 1.34 0 000 .19c0 .06.08.15.19.25a3.86 3.86 0 00.38.3l.35.23z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.27 221.27l-.35-.23-.65-1.46a.42.42 0 00.5.25.2.2 0 00.11-.22c0 .2.11.75.12 1a1 1 0 00.27.66z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.77 240.78l-.2.56c-.19.56-.47 1.09-1 1.12s-.8-.79-.92-1.25a.14.14 0 010-.06.43.43 0 000-.05c-.07-.44 1-1.57 1-1.57z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78 227.16a27.3 27.3 0 00-.73-4.93 3.27 3.27 0 00-.56-.89 13.17 13.17 0 00-2.7-2.19c.08 0 .23-2.24.23-2.24a1.06 1.06 0 00.92-1.36c-.27-.93-.92-.45-1.16.44s-.45.12-.69-.81-.36-.73-.82-1.26a.91.91 0 00-1.48.4c-.17.54-.3 1.23-.3 1.23s.36 3.37 1.65 3.47c0 0 0 .2-.06.46l-2.08 1.2a6.51 6.51 0 01-.16-6.6s1.6-3.67 5.14-1.08c2.36 1.72 3 7.68 5.49 9.6 5.44 4.06-1.7 6.89-2.69 4.56z",
    fill: "url(#referral-back_svg__linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06 276.94c0 .5.27.62.82.62a14.74 14.74 0 002.31 0c.27-.12.95-.52.95-.25s.54.37.81.25.27-2.1.27-2.1h-2s-.68.12-.82.62-2.34.37-2.34.86z",
    fill: "url(#referral-back_svg__linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.34 276.94c0 .5.27.62.82.62a14.74 14.74 0 002.31 0c.27-.12.95-.52.95-.25s.54.37.81.25.27-2.1.27-2.1h-2s-.68.12-.82.62-2.34.37-2.34.86z",
    fill: "url(#referral-back_svg__linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57 218.39a.42.42 0 00.34-.17c.22-.29.24-.85.34-1.05a1 1 0 00.08-.5.94.94 0 01.06-.18c.14-.27.54-1.36 0-1.36s-.14 1.5-.41 1.36-.13-1.77-.27-2.31-.54-.27-.54.54v.39c-.03.94-.03 3.28.4 3.28z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94 213.5c1 .68 1 .68.68.95s.54.66.54.66v-.39c0-.81.4-1.08.54-.54s0 2.17.27 2.31-.13-1.36.41-1.36.14 1.09 0 1.36a.94.94 0 00-.06.18s.33 1 .47 1.72H207s2.45-3.39 2-4.75-1.5-2.86-3.4-2.31-2.44.13-2.72-.14-.88 1.63.06 2.31z",
    fill: "url(#referral-back_svg__linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.91 218.22a3.61 3.61 0 010 1.35 4.08 4.08 0 012.07-.26c-.12-.79 0-.92 0-.92h-1.18c-.14-.68-.47-1.72-.47-1.72a1 1 0 01-.08.5c-.1.2-.12.76-.34 1.05z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34 249.71l2.18 11.14 1.91 14.61h2.07c.12-2.49-.54-14.61-.54-14.61.54-6.31.54-18.18.54-18.18s0-1-.07-2.62a69.19 69.19 0 00-6.09 9.66z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 221.72s5.18 10 7.13 10 5.39-3.73 5.48-3.82c0 .14-1.31 5.36-2.43 12.19h11.3c-.17-5.34-.62-17.08-1.4-18.33a6.85 6.85 0 00-2.84-2.38h-.18a4.08 4.08 0 00-2.07.26 3.11 3.11 0 00-.45.22 7.42 7.42 0 00-2.41 1.25c-.52.64-5.09 5.89-5.09 5.89s-4.56-4.54-6-6.2z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_26-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.41 258.11l.73 17.35h2.08s.54-15.87 1.45-19.16a36.27 36.27 0 012.67-6.59 69.19 69.19 0 016.09-9.66h-11.3a113.46 113.46 0 00-1.72 18.06z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_4-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9 220.19c0 .42 1 1.53 1 1.53l1.05-1s-.1-1.17-.47-1.46-1-1.19-1.29-1.37.25.84.25 1.12-.44.75-.54 1.18z",
    fill: "url(#referral-back_svg__New_Gradient_Swatch_copy_23-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.35 186.84c-.45 1.42-.47 2.71-.07 3a.34.34 0 00.12.06c.53.17 1.35-1 1.84-2.51s.47-2.95-.05-3.12h-.13c-.52.05-1.26 1.13-1.71 2.57z",
    fill: "url(#referral-back_svg__linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.74 186.65c-.49 1.56-.61 2.82.42 3.22l.24.08a.34.34 0 01-.12-.06c-.4-.34-.38-1.63.07-3s1.19-2.52 1.71-2.54h.13l-.25-.08c-.87-.43-1.71.82-2.2 2.38z",
    fill: "url(#referral-back_svg__linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.32,
    cy: 187.14,
    rx: 2.49,
    ry: 0.81,
    transform: "rotate(-72.42 191.336 187.145)",
    fill: "url(#referral-back_svg__linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.78 187c-.27.85-.26 1.61 0 1.7s.73-.53 1-1.38.26-1.61 0-1.7-.73.5-1 1.38z",
    fill: "url(#referral-back_svg__linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.79 188.26l.12-.29a1.12 1.12 0 01.09-.72c.1-.25.2-.35.34-.34s.15 0 .19-.11a.3.3 0 000-.26.14.14 0 00-.14-.06l.11-.35s.09 0 .14.07l.11-.25.07.11-.11.26a1.1 1.1 0 01-.09.69c-.11.28-.23.34-.35.32s-.13 0-.18.13a.3.3 0 000 .28.14.14 0 00.17.06l-.11.36a.17.17 0 01-.18-.06l-.11.27z",
    fill: "url(#referral-back_svg__linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61 195.41c1.11 1.13 2.56 1.55 3.38 1a.83.83 0 00.21-.16c.77-.76.42-2.37-.79-3.6s-2.82-1.62-3.59-.87a1.46 1.46 0 00-.16.19c-.55.83-.17 2.3.95 3.44z",
    fill: "url(#referral-back_svg__linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.25 195.75c1.21 1.24 2.82 1.62 3.59.87l.36-.35a.83.83 0 01-.21.16c-.82.53-2.27.11-3.38-1s-1.5-2.61-1-3.42a1.46 1.46 0 01.16-.19l-.36.35c-.73.74-.41 2.35.84 3.58z",
    fill: "url(#referral-back_svg__linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.04,
    cy: 194.01,
    rx: 1.6,
    ry: 2.63,
    transform: "rotate(-44.47 156.05 194.009)",
    fill: "url(#referral-back_svg__linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.01,
    cy: 194.03,
    rx: 1.07,
    ry: 1.71,
    transform: "rotate(-44.47 156.011 194.036)",
    fill: "url(#referral-back_svg__linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 195l-.22-.21a.53.53 0 01-.29.22l-.24-.32a.45.45 0 00.28-.22.24.24 0 000-.32c-.09-.08-.18-.08-.32 0a.47.47 0 01-.63-.07.77.77 0 01-.24-.73l-.22-.21.11-.19.2.2a.46.46 0 01.24-.2l.24.31a.42.42 0 00-.24.19.23.23 0 000 .3c.07.07.16 0 .33 0a.47.47 0 01.63.11.76.76 0 01.24.75l.24.23z",
    fill: "url(#referral-back_svg__linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89 176.13a1.86 1.86 0 002.09.64.69.69 0 00.13-.11c.48-.47.26-1.46-.49-2.23s-1.75-1-2.22-.53a.52.52 0 00-.1.11c-.3.51-.1 1.41.59 2.12z",
    fill: "url(#referral-back_svg__linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.66 176.34c.75.77 1.75 1 2.23.54l.22-.22a.69.69 0 01-.13.11 1.86 1.86 0 01-2.09-.64c-.69-.71-.94-1.61-.59-2.12a.52.52 0 01.1-.11l-.23.21c-.48.47-.26 1.47.49 2.23z",
    fill: "url(#referral-back_svg__linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.77,
    cy: 175.26,
    rx: 0.99,
    ry: 1.63,
    transform: "rotate(-44.47 169.779 175.268)",
    fill: "url(#referral-back_svg__linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.75,
    cy: 175.28,
    rx: 0.66,
    ry: 1.06,
    transform: "rotate(-44.47 169.762 175.276)",
    fill: "url(#referral-back_svg__linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.34 175.9l-.13-.13a.37.37 0 01-.18.14l-.15-.2a.3.3 0 00.17-.13.15.15 0 000-.2c-.06-.06-.12 0-.2 0a.28.28 0 01-.39 0 .48.48 0 01-.15-.45l-.14-.14.07-.11.13.12a.29.29 0 01.14-.12l.15.19a.28.28 0 00-.15.12.13.13 0 000 .18c0 .05.1 0 .2 0a.29.29 0 01.39.07.46.46 0 01.15.46l.15.15z",
    fill: "url(#referral-back_svg__linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29 250.73a1.86 1.86 0 002.1.64l.13-.1c.47-.47.25-1.47-.5-2.23s-1.74-1-2.22-.54a.94.94 0 00-.09.12 1.82 1.82 0 00.58 2.11z",
    fill: "url(#referral-back_svg__linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.07 251c.75.76 1.74 1 2.22.53l.23-.21-.13.1a1.86 1.86 0 01-2.1-.64 1.82 1.82 0 01-.58-2.11.94.94 0 01.09-.12l-.22.22c-.48.42-.26 1.42.49 2.23z",
    fill: "url(#referral-back_svg__linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47 250.56c.63.65 1.46.86 1.85.47s.2-1.22-.43-1.86-1.46-.85-1.85-.47-.2 1.22.43 1.86z",
    fill: "url(#referral-back_svg__linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68 250.35c.41.41 1 .54 1.22.29s.14-.8-.27-1.22-.95-.55-1.21-.29-.14.8.26 1.22z",
    fill: "url(#referral-back_svg__linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.75 250.51l-.14-.13a.39.39 0 01-.18.14l-.15-.2a.33.33 0 00.18-.14.16.16 0 000-.2h-.2a.29.29 0 01-.39-.05.44.44 0 01-.14-.45l-.14-.13.06-.12.13.13a.29.29 0 01.15-.13l.15.19a.28.28 0 00-.15.13.13.13 0 000 .18h.21a.28.28 0 01.39.06.48.48 0 01.15.47l.15.14z",
    fill: "url(#referral-back_svg__linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.27 179.56a1.84 1.84 0 002.09.63l.13-.1c.48-.47.26-1.47-.49-2.23s-1.74-1-2.22-.53a.52.52 0 00-.1.11 1.86 1.86 0 00.59 2.12z",
    fill: "url(#referral-back_svg__linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.05 179.77c.75.77 1.74 1 2.22.54l.22-.22-.13.1a1.84 1.84 0 01-2.09-.63 1.86 1.86 0 01-.59-2.12.52.52 0 01.1-.11l-.23.21c-.47.46-.25 1.46.5 2.23z",
    fill: "url(#referral-back_svg__linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 229.16,
    cy: 178.69,
    rx: 0.99,
    ry: 1.63,
    transform: "rotate(-44.47 229.162 178.69)",
    fill: "url(#referral-back_svg__linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.66 179.17c.41.42 1 .55 1.21.29s.14-.8-.26-1.22-1-.54-1.22-.29-.14.8.27 1.22z",
    fill: "url(#referral-back_svg__linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73 179.33l-.14-.13a.39.39 0 01-.18.14l-.15-.2a.36.36 0 00.18-.13.17.17 0 000-.2c-.06-.06-.11-.05-.2 0a.29.29 0 01-.39-.05.45.45 0 01-.15-.44l-.14-.14.07-.11.13.12a.29.29 0 01.15-.13l.14.2a.21.21 0 00-.14.12.13.13 0 000 .18c0 .05.1 0 .21 0a.28.28 0 01.38.06.48.48 0 01.15.47l.15.15z",
    fill: "url(#referral-back_svg__linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.8 201.77a1.86 1.86 0 01-2.09.64l-.13-.1c-.47-.47-.25-1.47.5-2.23s1.74-1 2.22-.54l.09.12a1.82 1.82 0 01-.59 2.11z",
    fill: "url(#referral-back_svg__linear-gradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 202c-.75.76-1.75 1-2.22.53l-.23-.21.13.1a1.86 1.86 0 002.09-.64 1.82 1.82 0 00.59-2.11l-.09-.12.22.22c.51.46.29 1.46-.49 2.23z",
    fill: "url(#referral-back_svg__linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63 201.6c-.63.65-1.46.86-1.85.47s-.2-1.22.43-1.86 1.46-.85 1.85-.47.2 1.26-.43 1.86z",
    fill: "url(#referral-back_svg__linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.41 201.39c-.41.41-.95.54-1.21.29s-.14-.8.27-1.22.95-.55 1.21-.29.14.83-.27 1.22z",
    fill: "url(#referral-back_svg__linear-gradient-76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.28 201.43l.15-.14a.48.48 0 01.15-.47.28.28 0 01.39-.06c.1.05.16.06.21 0a.15.15 0 000-.18.28.28 0 00-.15-.13l.15-.19a.34.34 0 01.15.13l.12-.13.07.12-.14.13a.46.46 0 01-.14.45.29.29 0 01-.39.05c-.09-.06-.15-.06-.2 0a.16.16 0 000 .2.3.3 0 00.18.14l-.15.2a.39.39 0 01-.18-.14l-.14.13z",
    fill: "url(#referral-back_svg__linear-gradient-77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.62 226c-1 1-2.28 1.38-3 .91a1.24 1.24 0 01-.18-.14c-.69-.68-.37-2.12.71-3.22s2.51-1.44 3.19-.76a.7.7 0 01.14.16c.52.76.13 2.05-.86 3.05z",
    fill: "url(#referral-back_svg__linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.94 226.35c-1.08 1.1-2.51 1.44-3.2.77l-.32-.31a1.24 1.24 0 00.18.14c.74.47 2 .1 3-.91s1.34-2.33.84-3a.7.7 0 00-.14-.16l.33.31c.71.62.37 2.06-.69 3.16z",
    fill: "url(#referral-back_svg__linear-gradient-79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.34,
    cy: 224.79,
    rx: 2.35,
    ry: 1.43,
    transform: "rotate(-45.53 134.337 224.783)",
    fill: "url(#referral-back_svg__linear-gradient-80)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.37,
    cy: 224.81,
    rx: 1.52,
    ry: 0.95,
    transform: "rotate(-45.53 134.368 224.81)",
    fill: "url(#referral-back_svg__linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42 225.55l.22-.21a.69.69 0 01.21-.67.41.41 0 01.56-.1c.15.08.23.1.3 0a.2.2 0 000-.26.38.38 0 00-.22-.17l.21-.28a.38.38 0 01.21.18l.19-.18.1.17-.2.19a.69.69 0 01-.21.65.42.42 0 01-.57.06c-.12-.08-.2-.08-.28 0a.21.21 0 000 .28.43.43 0 00.25.2l-.21.28a.44.44 0 01-.26-.2l-.2.19z",
    fill: "url(#referral-back_svg__linear-gradient-82)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "referral-back_svg__cls-3",
    cx: 152.48,
    cy: 276.65,
    rx: 102.86,
    ry: 6.24
  }))));
};

export default SvgReferralBack;